import styled from 'styled-components';

export const FeedGallerySectionBlock = styled.div`
    height: calc(100vh - calc(100vw * (84.5 / 375)));
    overflow: scroll;
`;